import React from "react";
import "../../App.css";

export default function Enrolment() {
  return (
    <div className="enrolment-container">
      <h1 className="enrolment">Enrolment</h1>
      <div className="enrolment-info">
        <p>The Philippine Language School of Victoria offers classes for
people of all ages. Over 30 students (from Primary to
Secondary and VCE level, as well as beginners of all ages including
adults) have demonstrated their improved Filipino language skills from
attending the Saturday morning classes at Braybrook.
        </p>
        
        <p>Cost:</p>
        <ul>
              <li>&#8226; VCE FILIPINO UNIT 1 to 4  :  $ 350</li>
              <li>&#8226; Primary to Year 10 :  $300</li>
              <li>&#8226; Adult Class:  $ 400 (35 sessions)</li> 
        </ul>
        <p>Classes run during the school term on Saturdays from 9AM to 12PM</p>
        <h2>Venue</h2>
        <p>BRAYBROOK SECONDARY COLLEGE</p>
        <p>352 BALLARAT RD. BRAYBROOK (enter through Burke Street)</p>
        <h2>Email</h2>
        <p>phillangsov@gmail.com</p>
        <h2>Contact Number</h2>
        <p>0412 836 883</p>
      </div>
    </div>
  );
}
